import React from 'react';
import {useTranslation} from 'react-i18next';
import {NodeType} from 'crqlar-react-common/dist/models/automation/automation';

import {insertNodeCategories, nodeCategories, stepNodeCategories} from '../../config/nodeCategories';
import type {AddNodePicker} from '../../hooks/useAddNodeGestures';
import NodeSelectorPopover from './NodeSelectorPopover';

type AddHandler = (nodeType: NodeType, label: string) => void;

export interface AddNodePickersProps {
    picker: AddNodePicker | null;
    onClose: () => void;
    onToolbarAdd: AddHandler;
    onToolbarDrop: (nodeType: NodeType, label: string, client: {x: number; y: number}) => void;
    onEdgeInsert: AddHandler;
    onPaneAdd: AddHandler;
    onAppend: AddHandler;
}

/** The four add-node pickers (`useAddNodeGestures`). The two that attach to a step offer no triggers; the splice offers no Stop. */
const AddNodePickers: React.FC<AddNodePickersProps> = ({
    picker,
    onClose,
    onToolbarAdd,
    onToolbarDrop,
    onEdgeInsert,
    onPaneAdd,
    onAppend
}) => {
    const {t} = useTranslation();

    return (
        <>
            <NodeSelectorPopover
                anchorEl={picker?.kind === 'toolbar' ? picker.anchorEl : null}
                onClose={onClose}
                onAddNode={onToolbarAdd}
                onDropNode={onToolbarDrop}
                nodeCategories={nodeCategories}
            />

            <NodeSelectorPopover
                anchorEl={picker?.kind === 'edge' ? picker.anchorEl : null}
                onClose={onClose}
                onAddNode={onEdgeInsert}
                nodeCategories={insertNodeCategories}
                title={t('Insert node')}
            />

            <NodeSelectorPopover
                anchorPosition={picker?.kind === 'pane' ? picker.anchorPosition : null}
                onClose={onClose}
                onAddNode={onPaneAdd}
                nodeCategories={nodeCategories}
            />

            <NodeSelectorPopover
                anchorEl={picker?.kind === 'append' ? picker.anchorEl : null}
                onClose={onClose}
                onAddNode={onAppend}
                nodeCategories={stepNodeCategories}
                title={t('Add next step')}
            />
        </>
    );
};

export default AddNodePickers;
